import Axios from 'axios';
import { call, takeLatest, put, cancelled } from 'redux-saga/effects';
import get from 'lodash/get';
import moment from 'moment-timezone';
import instance from '@api/axiosInstance';
import { getDimensionData } from '@src/api/dimensionContainer';
import { APP_VIEWER_SESSIONS_METRIC_FIELDS, APP_VIEWER_SESSIONS_QUERY_CONFIG } from './constants';
import * as dataTypes from './types';
import { UPDATE_QUERY } from './types';

function* fetchAppViewerSessionData(action: {
  query: {
    filter?: any[];
    metrics?: string[];
    metricFilter?: any[];
    interval: {
      from: string;
      granularity: string;
      to: string;
    };
    dimensions?: string[];
    sortBy?: any[];
    dataScope?: string;
  };
}) {
  const {
    query: {
      filter = [],
      metrics = APP_VIEWER_SESSIONS_METRIC_FIELDS,
      metricFilter,
      interval,
      dimensions = [],
      sortBy = [],
      dataScope,
    },
  } = action;

  const customPayload: {
    type?: 'multi-group-by' | 'group-by';
    dataset: string;
    metrics?: string[];
    metricFilter?: any[];
    interval?: string;
    filter: any[];
    limit: number;
    granularity: 'ALL';
    groupBy?: string[];
    orderBy: 'desc' | 'asc';
    options: {
      withTotals: true;
    };
    sortBy: any[];
  } = {
    type: 'group-by',
    dataset: 'AppExperience',
    metrics,
    interval: `${moment(interval.from).format()}/${moment(interval.to).format()}`,
    granularity: 'ALL',
    filter: filter.concat(APP_VIEWER_SESSIONS_QUERY_CONFIG.filter),
    limit: 1500,
    groupBy: dimensions.length > 0 ? dimensions : ['app_user_id'],
    orderBy: 'desc',
    options: {
      withTotals: true,
      ...(dataScope && { dataScope }),
    },
    sortBy,
  };
  if (metricFilter && metricFilter.length > 0) {
    customPayload.metricFilter = metricFilter;
    customPayload.type = 'multi-group-by';
  }
  const payload = { queries: [customPayload] };
  yield put({
    type: UPDATE_QUERY,
    query: payload,
  });
  yield put({
    type: dataTypes.FETCHING,
    query: payload,
  });
  const source = Axios.CancelToken.source();
  try {
    const resp = yield call(
      getDimensionData,
      payload,
      {
        cancelToken: source.token,
      },
      instance,
    );
    const data = get(
      resp.data,
      `${customPayload.type === 'multi-group-by' ? 'metricFilterData.' : ''}0.data.0.results`,
      [],
    );
    yield put({
      type: dataTypes.FETCHING_SUCCESS,
      response: data,
    });
  } catch (err) {
    yield put({
      type: dataTypes.FETCHING_FAIL,
    });
  } finally {
    if (yield cancelled()) {
      source.cancel();
    }
  }
}

function* watchFetchData() {
  yield takeLatest([dataTypes.FETCH_DATA], fetchAppViewerSessionData);
}

export default [watchFetchData];
